module.exports = __webpack_public_path__ + "img/popular-categories-3.3c2c10ca.png";